'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'court-sport';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e643';
var svgPathData = ['M32 96l0 32 32 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-32 0 0 32c0 17.7 14.3 32 32 32l240 0 0-97.3c-45.4-7.6-80-47.1-80-94.7s34.6-87.1 80-94.7L304 64 64 64C46.3 64 32 78.3 32 96zm0 64l0 192 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0zm224 96c0 29.8 20.4 54.9 48 62l0-124c-27.6 7.1-48 32.2-48 62zM336 64l0 97.3c45.4 7.6 80 47.1 80 94.7s-34.6 87.1-80 94.7l0 97.3 240 0c17.7 0 32-14.3 32-32l0-32-32 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l32 0 0-32c0-17.7-14.3-32-32-32L336 64zm0 130l0 124c27.6-7.1 48-32.2 48-62s-20.4-54.9-48-62zm208-2l0 128c0 17.7 14.3 32 32 32l32 0 0-192-32 0c-17.7 0-32 14.3-32 32z', 'M64 64C46.3 64 32 78.3 32 96l0 32 32 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-32 0 0 32c0 17.7 14.3 32 32 32l240 0 0-97.3c-45.4-7.6-80-47.1-80-94.7s34.6-87.1 80-94.7L304 64 64 64zM336 350.7l0 97.3 240 0c17.7 0 32-14.3 32-32l0-32-32 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l32 0 0-32c0-17.7-14.3-32-32-32l-240 0 0 97.3c45.4 7.6 80 47.1 80 94.7s-34.6 87.1-80 94.7zM336 194l0 124c27.6-7.1 48-32.2 48-62s-20.4-54.9-48-62zm-32 0c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62l0-124zM32 160l0 192 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0zM576 352l32 0 0-192-32 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCourtSport = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;